import {NgModule} from '@angular/core'
import {SortingBarComponent} from './sorting-bar/sorting-bar.component'
import {SortingComponent} from './sorting.component'
import {FilterModule} from '../filter/filter.module'
import {CommonModule} from '@angular/common'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {I18nDirective} from '../i18n/i18n.directive'

@NgModule({
  imports: [FilterModule, CommonModule, FontAwesomeModule, I18nDirective],
  declarations: [SortingBarComponent, SortingComponent],
  exports: [SortingBarComponent, SortingComponent],
})
export class SortingModule {}
